import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {getAuth} from "@angular/fire/auth";
import {NgIf} from "@angular/common";
import {WarningMessageComponent} from "../../../shared/components/messages/warning-message/warning-message.component";

@Component({
    selector: 'app-validate-email',
    templateUrl: './validate-email.component.html',
    styleUrls: ['./validate-email.component.scss'],
    imports: [
        NgIf,
        WarningMessageComponent
    ]
})
export class ValidateEmailComponent implements OnInit {
  sendingVerificationEmail = false
  verificationEmailSent = false
  checkingVerification = false
  emailNotVerified = false

  constructor(
    private authSvc: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  async checkVerification() {
    this.checkingVerification = true;
    const auth = getAuth();

    if (!auth.currentUser) {
      this.emailNotVerified = true;
      this.checkingVerification = false;
      return;
    }

    // Refresh user info from Firebase
    await auth.currentUser.reload();

    if (auth.currentUser.emailVerified) {
      await this.router.navigate(['/on-boarding']);
      return;
    }

    this.emailNotVerified = true;
    this.checkingVerification = false;
  }

  async resendVerification() {
    this.sendingVerificationEmail = true;
    this.verificationEmailSent = false

    await this.authSvc.sendVerificationEmail()

    this.verificationEmailSent = true;
    this.sendingVerificationEmail = false
  }
}
